/* tslint:disable:max-line-length */
/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

export const LogoImage: React.SFC = () => {
  return (
      <svg width="114px" height="25px" id="Layer_1" x="0px" y="0px" viewBox="0 0 114 25" xmlSpace="preserve">
          <g>
              <path fill="#31374F" d="M103,3v11c0,2.3,0.1,3,1,4s2.4,1.1,3,1.1s2.2-0.1,3-1.1s1-1.6,1-4V3h3v12c0,2-0.6,3.6-2,5c-1.3,1.3-3,2-5,2 s-3.8-0.7-5-2c-1.4-1.4-2-3-2-5V3H103z"/>
              <polygon fill="#31374F" points="36.2,3 41.5,15.5 46.8,3 50,3 41.4,23 33,3"/>
              <rect x="56" y="3" fill="#31374F" width="3" height="19"/>
              <path fill="#31374F" d="M73.8,13.9L80,22h-3.7l-5.7-7.8H70V22h-3V3h3.5c2.6,0,4.6,0.5,5.7,1.4c1.3,1.1,1.9,2.4,1.9,4.2 c0,1.3-0.4,2.5-1.2,3.5C76.2,13,75.1,13.6,73.8,13.9z M70,11.7h1c2.9,0,4.3-1,4.3-3.1c0-1.9-1.4-2.9-4.2-2.9H70V11.7z"/>
              <polygon fill="#31374F" points="91,6 91,22 88,22 88,6 84,6 84,3 95,3 95,6"/>
              <path fill="#31374F" d="M0,0v25h25V0H0z M22,22H3V3h19V22z"/>
              <polygon fill="#31374F" points="17,15 11,9 9,11 13,15"/>
          </g>
      </svg>
  )
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/images/logo/Logo.tsx